export default __webpack_public_path__ + "static/media/radiology-bg.2487cff5.webp";